import React from 'react';
//
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const ReFetchImportedCar = ({ visible, onCancel, car, handleReFetch }) => {
  const handleSubmit = () => {
    handleReFetch(car?._id);
    onCancel();
  };

  if (!car) return <></>;

  return (
    <Modal
      type="primary"
      title="Retry Failed Import"
      visible={visible}
      footer={[
        <div key="1" className="car-modal-footer">
          <Button
            size="default"
            style={{ backgroundColor: '#155BDC', color: '#fff' }}
            key="submit"
            onClick={handleSubmit}
          >
            Retry Import
          </Button>
          <Button size="default" type="white" key="back" outlined onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
      onCancel={onCancel}
    >
      <div className="car-modal">
        <BasicFormWrapper>
          <p>Retry failed import for &quot;{car?.meta?.name}&quot;</p>
          <i>You are about to retry importing the {car?.meta?.name} that previously failed</i>
        </BasicFormWrapper>
      </div>
    </Modal>
  );
};

export default ReFetchImportedCar;
